import { render, staticRenderFns } from "./CarFaxControl.vue?vue&type=template&id=ca3b2e24&scoped=true"
import script from "./CarFaxControl.vue?vue&type=script&lang=js"
export * from "./CarFaxControl.vue?vue&type=script&lang=js"
import "./CarFaxControl.vue?vue&type=style&index=0&id=ca3b2e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b2e24",
  null
  
)

export default component.exports